(function($){
  var stickySidebar = {
    init: function(){
      if ($('.sidebar').length){
        stickySidebar.initSidebar();
      }
    },
    initSidebar: function(){
      var $height = $('.sided-container').height();
      var $headerHeight = $('.header__content').height();
      var $sidebar = $('.sidebar');
      var $sidebarChild = $('.sidebar__content');
      var $offLeft = $sidebar.offset().left;
      var $offTop = $sidebar.offset().top;
      var $offBottom = $height + $sidebar.offset().top;
      var $offFull = $offBottom - $sidebarChild.innerHeight();

      if ($(window).width() >= 768) {
        $sidebar.css('height', $height);
      } else {
        $sidebar.css('height', 'auto');
      }

      $(window).on('scroll', function() {
        var $win = $(this);
        if ($win.width() >= 768) {
          var $winTop = $(window).scrollTop() + $headerHeight;
          if ($winTop > $offTop) {
            $sidebarChild.addClass('sticky');
            $sidebarChild.css('left', $offLeft);
          }
          if ($offTop > $winTop && $sidebarChild.hasClass('sticky')) {
            $sidebarChild.removeClass('sticky');
          }
          if ($winTop > $offFull && $sidebarChild.hasClass('sticky')) {
            $sidebarChild.removeClass('sticky').addClass('bottom');
            $sidebarChild.css('left', '0');
          }
          if ($offFull > $winTop && $sidebarChild.hasClass('bottom')) {
            $sidebarChild.removeClass('bottom').addClass('sticky');
            $sidebarChild.css('left', $offLeft);
          }
        }
      });
    }
  };
  $(document).ready(stickySidebar.init);
  $(window).on('resize', function(){
    stickySidebar.init();
  });
})(jQuery);
